import Rollbar from "rollbar";

import { getConfig } from "../../../_configs/AppConfig";

const { publicRuntimeConfig } = getConfig();

const baseConfig: Rollbar.Configuration = {
  accessToken: publicRuntimeConfig.rollbar.post_client_access_token,
  autoInstrument: false,
  environment: publicRuntimeConfig.APP_ENV,
  captureUncaught: false,
  captureUnhandledRejections: false,
  enabled: publicRuntimeConfig.APP_ENV === "prod",
  payload: {
    client: {
      javascript: {
        code_version: publicRuntimeConfig.REACT_FRONTEND_VERSION,
      },
    },
  },
  // replay is breaking helpscout chat and causing random other errors - disable hopefully until it gets out of beta
  // replay: {
  //     enabled: true
  // }
};

export const clientConfig: Rollbar.Configuration = {
  checkIgnore: function (isUncaught, args, payload: Rollbar.Payload) {
    if (
      isUncaught &&
      payload.body?.trace?.frames &&
      /DangerouslySetHtmlContent/.exec(
        payload.body.trace.frames[payload.body.trace.frames.length - 1].method,
      )
    ) {
      // uncaught exceptions in DangerouslySetHtmlContent are almost definitely from userGenerated code, but we
      // can't know that in the ErrorBoundary because the error is thrown asynchronously when inserting into the
      // DOM, which is not caught by React Error Boundaries. So if we're here, it's pretty safe to ignore it.
      return true;
    }
    // return true to ignore, otherwise will be reported
    const errorClassesToIgnore: string[] = ["ChunkLoadError"];
    const errorMessageRegexesToIgnore: RegExp[] = [
      /^attempted to hard navigate to the same URL/,
      /^Load failed$/,
      /^Unexpected token '<'$/,
      /^\$ is not defined$/,
      /^Can't find variable: \$$/,
      /^Script error\.$/,
    ];

    if (errorClassesToIgnore.includes(payload.body.trace.exception.class)) {
      return true;
    } else if (
      errorMessageRegexesToIgnore.some((r) =>
        r.exec(payload.body.trace.exception.message),
      )
    ) {
      return true;
    }
    return false;
  },
  ...baseConfig,
};

// serverConfig cannot contain functions, which cannot be serialized to be passed to client components
export const serverConfig = {
  ...baseConfig,
};
